import {
  LEARNER_ACCESS_TOKEN_KEY,
  LEARNER_INFO_KEY,
  LEARNER_REFRESH_TOKEN_KEY,
  LEARNER_SESSION_CLEARED_EVENT,
  LEARNER_SESSION_UPDATED_EVENT,
} from "./constants"
import type { StudentInfo } from "./types"

const TEACHER_SESSION_KEYS = [
  "access_token",
  "refresh_token",
  "username",
  "email",
  "userId",
] as const

export const getLearnerAccessToken = (): string | null =>
  localStorage.getItem(LEARNER_ACCESS_TOKEN_KEY)

export const getLearnerRefreshToken = (): string | null =>
  localStorage.getItem(LEARNER_REFRESH_TOKEN_KEY)

export const hasLearnerSession = (): boolean => !!getLearnerAccessToken()

export const getStoredStudentInfo = (): StudentInfo | null => {
  const raw = localStorage.getItem(LEARNER_INFO_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw) as StudentInfo
  } catch {
    return null
  }
}

export const saveLearnerSession = (
  accessToken: string,
  refreshToken: string,
  student: StudentInfo
): void => {
  // Mutual exclusivity — avoid dual teacher + learner sessions.
  TEACHER_SESSION_KEYS.forEach((key) => localStorage.removeItem(key))

  localStorage.setItem(LEARNER_ACCESS_TOKEN_KEY, accessToken)
  localStorage.setItem(LEARNER_REFRESH_TOKEN_KEY, refreshToken)
  localStorage.setItem(LEARNER_INFO_KEY, JSON.stringify(student))
  window.dispatchEvent(new Event(LEARNER_SESSION_UPDATED_EVENT))
}

export const updateLearnerAccessToken = (accessToken: string): void => {
  localStorage.setItem(LEARNER_ACCESS_TOKEN_KEY, accessToken)
}

export const updateStoredStudentInfo = (student: StudentInfo): void => {
  localStorage.setItem(LEARNER_INFO_KEY, JSON.stringify(student))
  window.dispatchEvent(new Event(LEARNER_SESSION_UPDATED_EVENT))
}

export const clearLearnerSession = (): void => {
  localStorage.removeItem(LEARNER_ACCESS_TOKEN_KEY)
  localStorage.removeItem(LEARNER_REFRESH_TOKEN_KEY)
  localStorage.removeItem(LEARNER_INFO_KEY)
  window.dispatchEvent(new Event(LEARNER_SESSION_CLEARED_EVENT))
}

/** Clear teacher tokens when a learner signs in (or vice versa helpers). */
export const clearTeacherSessionKeys = (): void => {
  TEACHER_SESSION_KEYS.forEach((key) => localStorage.removeItem(key))
}
